import React from 'react';
import { ExpansionPanel as ExpansionPanelBase, ExpansionPanelSummary as ExpansionPanelSummaryBase, ExpansionPanelDetails as ExpansionPanelDetailsBase } from '@material-ui/core';
import { Icon } from 'semantic-ui-react';
import './index.css';
export class ExpansionPanelSummary extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  render() {
    return /*#__PURE__*/React.createElement("div", this.props);
  }
}
export class ExpansionPanelDetails extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  render() {
    const {
      children,
      className: classNameProp,
      ...rest
    } = this.props;
    let className = 'expansionDetailsRoot';
    if (classNameProp) className = "".concat(className, " ").concat(classNameProp);
    return /*#__PURE__*/React.createElement(ExpansionPanelDetailsBase, Object.assign({
      classes: {
        root: className
      }
    }, rest), children);
  }
}
export class ExpansionPanel extends React.Component {
  constructor(_props) {
    super(_props);
    this.handleToggleOpen = e => {
      // if (e) e.stopPropagation();
      this.expanded = !this.expanded;
      if (!this.baseRef) return;
      const summaryPanel = this.baseRef.children[0];
      const detailsPanelWrapper = this.baseRef.children[1];
      // const expandIcon = this.baseRef.querySelector('.expandIcon');
      // console.log('detailsPanel:', detailsPanel);
      // console.log('expandIcon:', expandIcon);

      /* Toggle panel details visibility and expand icon orientation */
      if (this.expanded) {
        /* In the case that children are not being rendered until open, give 10ms buffer */
        const height = detailsPanelWrapper.firstChild.clientHeight.toString();
        detailsPanelWrapper.style.height = height.concat('px');
        // setTimeout(() => {
        //     /* Make sure this.expanded didn't toggle again during the 100ms timeout */
        //     if (this.expanded) {
        //         const height = detailsPanelWrapper.firstChild.clientHeight.toString();
        //         detailsPanelWrapper.style.height = height.concat('px');
        //     }
        // }, 50);
        setTimeout(() => {
          /* Make sure this.expanded didn't toggle again during the 100ms timeout */
          if (this.expanded) detailsPanelWrapper.style.height = 'auto';
        }, 500);
        // detailsPanel.style.overflow = 'visible';
      } else {
        // eslint-disable-next-line no-lonely-if
        if (e) {
          /* Toggled based on click, not called from handlePanelRef */
          const height = detailsPanelWrapper.clientHeight.toString();
          detailsPanelWrapper.style.height = height.concat('px');
          setTimeout(() => {
            /* Make sure this.expanded didn't toggle again during the 10ms timeout */
            if (!this.expanded) detailsPanelWrapper.style.height = '0px';
          }, 50);
        } else {
          /* Called from handlePanelRef - skip transition */
          detailsPanelWrapper.style.height = '0px';
        }
      }

      /* Update class names for indicating expansion state */
      this.baseRef.classList.toggle('expansionRootExpanded');
      summaryPanel.classList.toggle('expansionSummaryExpanded');
      Array.from(summaryPanel.children || []).forEach(child => child.classList.toggle('expansionSummaryExpanded'));
      this.forceUpdate();
    };
    this.handleClick = e => {
      const {
        onClick,
        disabled
      } = this.props;
      if (!disabled) {
        if (onClick) onClick(e);
        this.handleToggleOpen(e);
      }
      e.stopPropagation();
    };
    // eslint-disable-next-line react/sort-comp
    this.handleKeyDown = e => {
      // console.log('e:', e);
      const {
        onKeyDown,
        onClick,
        disabled
      } = this.props;
      if (!disabled) {
        // // Check if key is already down to avoid repeats being counted as multiple activations
        // if (
        //     focusRipple &&
        //     !keydownRef.current &&
        //     focusVisible &&
        //     rippleRef.current &&
        //     e.key === ' '
        // ) {
        //     keydownRef.current = true;
        //     e.persist();
        //     rippleRef.current.stop(e, () => {
        //         rippleRef.current.start(e);
        //     });
        // }

        if (onKeyDown) onKeyDown(e);

        // Keyboard accessibility for non interactive elements
        if (e.target === e.currentTarget && [' ', 'Enter'].includes(e.key)) {
          // console.log('calling onclick');
          e.preventDefault();
          if (onClick) onClick(e);
          this.handleToggleOpen(e);
        }
      }
      e.stopPropagation();
    };
    // eslint-disable-next-line no-undef
    this.handleKeyUp = e => {
      const {
        onKeyUp,
        onClick,
        disabled
      } = this.props;
      if (!disabled) {
        // if (focusRipple && e.key === ' ' && rippleRef.current && focusVisible) {
        //     keydownRef.current = false;
        //     e.persist();
        //     rippleRef.current.stop(e, () => {
        //         rippleRef.current.pulsate(e);
        //     });
        // }
        if (onKeyUp) onKeyUp(e);

        // Keyboard accessibility for non interactive elements
        // if (e.target === e.currentTarget && [' ', 'Enter'].includes(e.key)) {
        //     e.preventDefault();
        //     if (onClick) onClick(e);
        //     this.handleToggleOpen(e);
        // }
      }
      e.stopPropagation();
    };
    this.handlePanelRef = ref => {
      if (!ref) return;
      /* Store reference */
      this.baseRef = ref.firstChild;
      // console.log('this.baseRef:', this.baseRef);

      /* If it should not be expanded, we need to toggle it immediately to collapse */
      if (!this.expanded) {
        this.expanded = true;
        this.handleToggleOpen();
      }

      /* Update initial styles */
      const detailsPanelWrapper = this.baseRef.children[1];
      detailsPanelWrapper.style.overflow = 'hidden';
      detailsPanelWrapper.style.transitionDuration = '206ms';

      /* Override onclick to prevent internal handling */
      const summaryPanel = this.baseRef.children[0];
      summaryPanel.onclick = this.handleClick;
      summaryPanel.onkeydown = this.handleKeyDown;
      summaryPanel.onkeyup = this.handleKeyUp;
    };
    this.ExpansionPanelSummaryClone = props => {
      const {
        className: classNameProp,
        onClick,
        expandIcon: expandIconProp,
        ...rest
      } = props;
      let className = 'expansionSummaryRoot';
      if (classNameProp) className = "".concat(className, " ").concat(classNameProp);
      // console.log('props:', props);
      const expandIcon = expandIconProp || /*#__PURE__*/React.createElement(Icon, {
        name: "chevron down",
        className: "expandDownIcon"
      });
      return /*#__PURE__*/React.createElement(ExpansionPanelSummaryBase
      // ref={this.handlePanelSummaryRef}
      , Object.assign({
        classes: {
          root: className,
          expanded: 'expansionSummaryExpanded',
          disabled: 'expansionSummaryDisabled',
          expandIcon: 'expandIcon'
        },
        expandIcon: expandIcon
      }, rest));
    };
    const {
      expanded,
      defaultExpanded
    } = this.props;
    this.controlled = typeof expanded === 'boolean';
    this.expanded = this.controlled ? expanded : defaultExpanded || false;
    // console.log('expanded', expanded, 'defaultExpanded:', defaultExpanded, 'this.expanded:', this.expanded);
  }
  render() {
    const {
      children: childrenProp,
      expanded,
      className: classNameProp,
      style,
      ...rest
    } = this.props;
    let className = 'expansionRoot';
    if (classNameProp) className = "".concat(className, " ").concat(classNameProp);

    /* Material-UI does something weird where we need to actually call their original summary component, and just pass props through */
    const [summary, ...children] = React.Children.toArray(childrenProp);
    const summaryProps = (summary || {}).props || {};
    // console.log('restSummaryProps:', summaryProps);

    const PanelSummary = this.ExpansionPanelSummaryClone(summaryProps);
    // console.log('PanelSummary:', PanelSummary);

    return /*#__PURE__*/React.createElement("div", {
      ref: this.handlePanelRef,
      className: "expansionPanelWrapper",
      style: style
    }, /*#__PURE__*/React.createElement(ExpansionPanelBase, Object.assign({
      classes: {
        root: className,
        expanded: 'expansionRootExpanded',
        disabled: 'expansionRootDisabled'
      },
      expanded: true
    }, rest), PanelSummary, this.expanded && children));
  }
}